const setupLiveChatTriggers = () => {
  document.addEventListener('DOMContentLoaded', function () {
    const chatTriggers = document.querySelectorAll('[data-live-chat]')
    if (chatTriggers) {
      chatTriggers.forEach((el, i) => {
        el.addEventListener('click', () => {
          if (window.zE) {
            window.zE('messenger', 'open')
          }
        })
      })
    }
  })
}

export {
  setupLiveChatTriggers
}
